var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "MainLayout" },
    [
      _c(
        "div",
        { attrs: { id: "header" } },
        [
          _c("headr", {
            ref: "topheader",
            attrs: {
              color: _vm.headerOptions.color,
              image: _vm.headerOptions.image
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c("footer", { attrs: { id: "footer" } }, [_c("foot")], 1)
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a36d9ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a36d9ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/comps/MainLayout.vue
// module id = 560
// module chunks = 0